import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { EditorComponent, EditorModule } from "@progress/kendo-angular-editor";
import {
  CancelEvent,
  ErrorEvent,
  FileInfo, FileRestrictions,
  FileState,
  KENDO_UPLOAD,
  PauseEvent, RemoveEvent, ResumeEvent,
  SelectEvent, SuccessEvent, UploadComponent, UploadEvent, UploadProgressEvent,
  UploadsModule
} from "@progress/kendo-angular-upload";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { CommonModule } from "@angular/common";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { LabelModule } from "@progress/kendo-angular-label";
import { AppConfig, CONFIG_TOKEN } from "../../setup/config";
import { ImageUploadService } from "../editor-image-upload.service";
import { SecurityService } from '../../auth/security.service';
import { environment } from '../../../environments/environment';
import { LoggerService } from '../../shared/logger.service';
import { CasiFileInfo } from '../../common/obj.lib';
import { FormsModule } from '@angular/forms';
import { toInteger } from 'lodash';
import { HttpResponse } from '@angular/common/http';

const { apiUrl } = environment;

export interface FileInfoCasi extends FileInfo {
  filePackage: string
}

@Component({
  selector: 'casi-editor-file-uploader',
  standalone: true,
  imports: [
    FormsModule,
    EditorModule,
    DialogsModule,
    CommonModule,
    InputsModule,
    ButtonsModule,
    KENDO_UPLOAD,
    LabelModule,
    UploadsModule
  ],
  templateUrl: './editor-file-uploader.component.html',
  styleUrl: './editor-file-uploader.component.scss'
})
export class EditorFileUploaderComponent implements OnInit, OnDestroy {

  @Output() onLoad = new EventEmitter<CasiFileInfo[]>();
  @Input() public editor: EditorComponent = <EditorComponent>{};
  @Input({ required: true }) userStoryId: number | undefined;
  @Input({ required: true }) tableName: string = null as any;

  public opened = false;

  private fileName: string = "";
  private filesUploaded: FileInfo[] = [];
  @ViewChild("myUpload") public dialogFile: EditorFileUploaderComponent = <EditorFileUploaderComponent>{};
  public myFiles: Array<FileInfo> | null = null;
  private myCasiFiles: Array<CasiFileInfo> = [];

  uploadSaveUrl: string = "fileupload";
  uploadRemoveUrl = "removeupload";

  fileRestrictions: FileRestrictions = {
    maxFileSize: 104857600,
    // allowedExtensions: [".png", ".jpeg", ".jpg"]
  };

  constructor(
    private logger: LoggerService,
    @Inject(CONFIG_TOKEN) private config: AppConfig,
    private dataService: ImageUploadService,
    private securityService: SecurityService
  ) { }

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...');
    this.securityService.requestCsrfToken();
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
  }

  open() {
    this.opened = true;
    this.uploadSaveUrl = `${apiUrl}/fileupload?tablename=${this.tableName}&userstoryid=${this.userStoryId}`;
  }

  public close(): void {
    this.resetUploads();
    this.opened = false;
  }

  public insert(): void {
    this.logger.debug(`insert: myfiles: `, this.myFiles);
    let toInsert: CasiFileInfo[] = [];
    if (this.myFiles && this.myFiles.length > 0) {
      toInsert = this.myCasiFiles; //();
      this.logger.debug(`insert: toInsert: `, toInsert);
    }
    this.onLoad.emit(toInsert)
    this.opened = false;
    this.resetUploads();
  }

  //#region Upload event handlers

  public remove(upload: UploadComponent, uid: string): void {
    upload.removeFilesByUid(uid);
  }

  public showButton(state: FileState): boolean {
    return state === FileState.Uploaded ? true : false;
  }
  public cancel(e: CancelEvent): void {
    this.logger.debug(`cancel event...`, e);
  }

  public clear(): void {
    this.log("clear event");
  }

  public complete(): void {
    this.log(`complete event`);
  }

  public error(e: ErrorEvent): void {
    this.log(`error event: ${e.files[0].name}`);
  }

  public blur(): void {
    this.log(`blur event`);
  }

  public focus(): void {
    this.log(`focus event`);
  }

  public pause(e: PauseEvent): void {
    this.log(`pause event ${e.file.name}`);
  }

  public resume(e: ResumeEvent): void {
    this.log(`resume event ${e.file.name}`);
  }

  // public remove(e: RemoveEvent): void {
  //   this.log(`remove event: ${e.files[0].name}`);
  //   this.resetData();
  // }

  public select(e: SelectEvent): void {
    this.logger.debug(`select event`, e);
  }

  public success(e: SuccessEvent): void {
    let file = e.files[0];
    let name = file.name;

    this.logger.debug(`success event ${name}`, e);
    this.logger.debug(`success file:`, file.rawFile);
    this.filesUploaded.push((e.files[0] as FileInfo)); // = name;
    if (e.response && e.response.body) {
      let filePackage = (e.response as any).body.filePackage;
      let casiFileInfo = new CasiFileInfo({
        uid: file.uid,
        filename: name,
        tablename: this.tableName,
        userStoryId: this.userStoryId,
        filePackage: filePackage,
        apiUrl
      });
      this.myCasiFiles?.push(casiFileInfo); // = this.myFiles?.map(mf => )
      this.logger.debug(`success: fileInfo: `, casiFileInfo);
    } else {
      this.myCasiFiles = this.myCasiFiles.filter(item => item.uid !== file.uid);
    }
    // this.myFiles?.push(casiFileInfo);
    this.logger.debug(`success: myfiles: `, this.myFiles);
    this.logger.debug(`success: myCasiFiles: `, this.myCasiFiles);

    // if (file.rawFile) {
    //   const reader = new FileReader();

    //   reader.onloadend = () => {
    //     this.logger.debug(`success:reader: `, reader);
    //     // const img = new Image();

    //     // img.src = <string>reader.result;
    //     // img.onload = () => {
    //     //   this.setImageInfo({
    //     //     src: img.src,
    //     //     height: img.height,
    //     //     width: img.width,
    //     //   });
    //     // };

    //     this.onLoad.emit({
    //       data: casiFileInfo
    //     });
    //   };

    //   reader.readAsDataURL(file.rawFile);
    // }

  }

  public upload(e: UploadEvent): void {
    this.log(`upload event ${e.files[0].name}`);
    this.securityService.secureUploads(e);
  }

  public uploadProgress(e: UploadProgressEvent): void {
    this.log(`uploadProgress event ${e.percentComplete}`);
  }

  public valueChange(e: FileInfo[]): void {
    if (e && e.length > 0)
      this.log(`valueChange event ${e[0].name}`);
  }

  private log(event: string): void {
    this.logger.debug(`log => ${event}`);
  }

  //#endregion

  //#region Private functions

  private resetUploads() {
    this.myFiles = null;
    this.filesUploaded.length = 0;
    this.myCasiFiles.length = 0;
  }
  //#endregion
}
